export enum C_LEAD_TYPE {
  /**
   * @member {string}
   * @description whatsapp
   */

  WHATSAPP = 1,

  /**
   * @member {string}
   * @description call
   */
  CALL = 2,

  /**
   * @member {string}
   * @description mail
   */
  MAIL = 3,

  /**
   * @member {string}
   * @description mortage referral
   */
  MORTAGE_REFERRAL = 4,
}

export const C_IS_CLICKED = {
  WHATSAPP: {
    value: 1,
    id: 1,
  },
  CALL: {
    value: 2,
    id: 2,
  },
  MAIL: {
    value: 3,
    id: 3,
  },
  MORTAGE_REFERRAL: {
    value: 4,
    id: 4,
  },
};
const { WHATSAPP, CALL, MAIL, MORTAGE_REFERRAL } = C_IS_CLICKED;
export const O_IS_CLICKED = {
  [WHATSAPP.id]: C_IS_CLICKED.WHATSAPP,
  [WHATSAPP.value]: C_IS_CLICKED.WHATSAPP,

  [CALL.id]: C_IS_CLICKED.CALL,
  [CALL.value]: C_IS_CLICKED.CALL,

  [MAIL.id]: C_IS_CLICKED.MAIL,
  [MAIL.value]: C_IS_CLICKED.MAIL,

  [MORTAGE_REFERRAL.id]: C_IS_CLICKED.MORTAGE_REFERRAL,
  [MORTAGE_REFERRAL.value]: C_IS_CLICKED.MORTAGE_REFERRAL,
};
export const A_PUBLIC = [C_IS_CLICKED.WHATSAPP, C_IS_CLICKED.MORTAGE_REFERRAL];
